// Replace APP_STORE_ID_PLACEHOLDER with the numeric Apple App Store ID
// (the digits after "id" in the App Store URL) once Nightdrift is listed.
// Example: "1234567890"
export const NIGHTDRIFT_APP_STORE_ID = "APP_STORE_ID_PLACEHOLDER";

export const NIGHTDRIFT_APP_STORE_URL =
  "https://apps.apple.com/us/app/nightdrift/id" + NIGHTDRIFT_APP_STORE_ID;

export const SUPPORT_EMAIL = "nightdrift@sadware.com";

export const YEARLY_PRODUCT_ID = "com.sadware.bestsleep.yearly";

export const APPLE_STANDARD_EULA_URL =
  "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/";
